import {
  Badge,
  Box,
  Button,
  Group,
  Image,
  List,
  Stack,
  Text
} from "@mantine/core";

import Logo from "modules/core/assets/img/mosaic.png";
import { TbCircleFilled } from "react-icons/tb";

// const features = [
//   {
//     title: "Hypothesis Grader",
//     color: "yellow"
//   },
//   {
//     title: "Collision Detection",
//     color: "blue"
//   },
//   {
//     title: "Experiment Insight Generation",
//     color: "green"
//   },
//   {
//     title: "Research Synthesis",
//     color: "red"
//   },
//   {
//     title: "Generate Ideas From Your Data",
//     color: "orange"
//   },
//   {
//     title: "Natural Language Querying",
//     color: "pink"
//   },
//   {
//     title: "Insight Decay & Conflicts",
//     color: "indigo"
//   }
// ];

const LoginSideContent = () => {
  return (
    <Box w="50%" h="100vh" bg="black">
      <Stack
        gap="lg"
        py={120}
        px="10%"
        c="white"
        align="flex-start"
        justify="center"
        w="100%"
        // ta="center"
        h="100%"
      >
        {/* <Image src={Logo} w={160} fit="contain" mb="md" /> */}
        <Badge color="yellow.4" variant="light" size="lg">
          New Feature
        </Badge>

        <div>
          <Text fz="h4" fw={700}>
            Brainstorm
          </Text>

          <Text fz="md" fw={400} maw={450} mb="xs">
            Vet & evaluate ideas before they enter your pipeline.
          </Text>
        </div>

        <List
          icon={<TbCircleFilled />}
          styles={{
            itemIcon: {
              color: "var(--mantine-color-yellow-5)",
              fontSize: 12,
              marginTop: 5
            },
            itemLabel: { fontSize: 14 },
            itemWrapper: { alignItems: "flex-start" }
          }}
        >
          <List.Item>
            Capture ideas from different sources - Mosaic Companion,
            Crowdsource, Add Hoc
          </List.Item>

          <List.Item>
            Mosaic&apos;s Context engine evaluates it against your own evidence,
            experiments and business goals
          </List.Item>

          <List.Item>
            Get the full picture on whether the idea is worth testing or not
          </List.Item>
        </List>

        {/* <Group justify="center" mt="xl" wrap="wrap" w="60%">
            {features.map((feature, index) => (
              <Badge
                key={index}
                tt="initial"
                size="lg"
                variant="light"
                color={feature.color}
                style={{ flexShrink: 0 }}
              >
                {feature.title}
              </Badge>
            ))}
          </Group> */}

        <Button
          color="violet"
          size="lg"
          radius="xl"
          component="a"
          href="https://efestra.crunch.help/en/efestra-for-experimentation-specialists/brainstorm-add-context-to-ideas-before-you-run-with-it"
          target="_blank"
          rel="noopener noreferrer"
          // h={72}
          // w={300}
          // className={classes.button}
        >
          Read the full guide
        </Button>
      </Stack>
    </Box>
  );
};

export default LoginSideContent;
